import { environment } from '@env/environment';
import { map } from 'rxjs/operators';
var VersionService = /** @class */ (function () {
    function VersionService(http) {
        this.http = http;
        this.endpoint = environment.ResourceServer + "version";
    }
    VersionService.prototype.getVersion = function () {
        return this.http.get("" + this.endpoint, { responseType: 'text' })
            .pipe(map(function (t) { return JSON.parse(t) == "light"; }));
    };
    return VersionService;
}());
export { VersionService };
